import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    Input,
    OnInit,
    Optional,
    Renderer2,
    Self,
    ViewChild
} from "@angular/core";
import { NgControl } from "@angular/forms";
import { AttributePresenceInput } from "@spscommerce/ng-utils";

import { SpsFormControlComponent } from "../forms/sps-form-control.abstract.component";

@Component({
    selector: "sps-toggle",
    templateUrl: "./sps-toggle.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [{ provide: SpsFormControlComponent, useExisting: SpsToggleComponent }]
})
export class SpsToggleComponent extends SpsFormControlComponent<boolean> implements OnInit {
    static readonly displayName = "sps-toggle";
    static readonly props = {
        statusLabel: "[string, string]",
        description: "string",
        large: "boolean",
    };

    @Input() statusLabel: [string, string];
    @Input() description: string;
    @Input()
    @AttributePresenceInput()
    large: boolean;

    statusLabelID: string;
    descriptionID: string;

    get activated(): boolean {
        return this.model;
    }
    set activated(newValue: boolean) {
        this.model = newValue;
    }

    @ViewChild("checkboxInput", { static: false }) inputElement: ElementRef;

    get currentStatusLabel() {
        return this.statusLabel ? this.statusLabel[+this.activated] : "";
    }

    constructor(
        el: ElementRef,
        renderer: Renderer2,
        @Self()
        @Optional()
        ngControl: NgControl,
        protected _changeDetector: ChangeDetectorRef
    ) {
        super(el, renderer, ngControl);
    }

    ngOnInit() {
        if (this.statusLabel) {
            this.statusLabelID = `${this.id}__status-label`;
        }
        if (this.description) {
            this.descriptionID = `${this.id}__description`;
        }
    }

    toggle() {
        this.activated = !this.activated;
        this._changeDetector.markForCheck();
        if (this._propagateChange) {
            this._propagateChange(this.activated);
        }
    }
}
